import styled from "styled-components";

interface ClockBottomSectionProps {
  primaryColor: string;
  secondaryColor: string;
}

const Container = styled.div<{ $primaryColor: string }>`
  padding: 0;
  margin: 0 auto;
  position: relative;
  font-family: Abel, cursive;
  font-weight: 700;
  background: ${(props) => props.$primaryColor};
`;

const TimeDisplay = styled.div<{ $secondaryColor: string }>`
  text-align: center;
  padding: 12px;
  border-radius: 6px;
  position: relative;
  color: ${(props) => props.$secondaryColor};
`;

export const ClockBottomSection = (
  props: ClockBottomSectionProps,
): JSX.Element => {
  const { primaryColor, secondaryColor } = props;
  return (
    <Container $primaryColor={primaryColor}>
      <TimeDisplay $secondaryColor={secondaryColor}>11:20</TimeDisplay>
    </Container>
  );
};
